import React, { useState, useEffect } from "react";
import { Select, Button, Typography, Spin } from "antd";
import "./PendingAll.less";
import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import {
  useGetUpcomingAssignmentsQuery,
  useGetSubmittedAssignmentsQuery,
} from "../../../redux/services/assignment";
import { useGetStudentBatchesQuery } from "../../../redux/services/batches";
import { useSelector } from "react-redux";
import { EmptyCard } from "../../../component";
import AssignmentCard from "../../../component/AssignmentCard/AssignmentCard";
import { useParams } from "react-router-dom";
import { StopOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const PendingAll = () => {
  const { student_id } = useSelector((state) => state.auth);
  const { coaching_id } = useParams();
  const [pendingFilters, setPendingFilters] = useState({
    coaching_name: null,
    batch_name: null,
    subject: null,
  });
  const [appliedFilters, setAppliedFilters] = useState({});
  const [coachingOptions, setCoachingOptions] = useState([]);

  const { data: pendingAssignments = [], isLoading: pendingLoading } =
    useGetUpcomingAssignmentsQuery({
      student_id: student_id,
      coaching_id: coaching_id,
      ...appliedFilters,
    });

  const { data: submittedAssignments = [], isLoading: submittedLoading } =
    useGetSubmittedAssignmentsQuery({
      student_id: student_id,
      coaching_id: coaching_id,
      ...appliedFilters,
    });

  const { data: batches } = useGetStudentBatchesQuery(student_id);

  useEffect(() => {
    if (batches?.data) {
      const uniqueCoachings = [
        ...new Set(batches.data.map((batch) => batch.coaching_name)),
      ];
      setCoachingOptions(
        uniqueCoachings.map((coaching) => ({
          value: coaching,
          label: coaching,
        }))
      );
    }
  }, [batches]);

  const handleFilterChange = (value, key) => {
    setPendingFilters({ ...pendingFilters, [key]: value });
  };

  const handleApplyFilters = () => {
    setAppliedFilters(pendingFilters);
  };

  const handleClearFilters = () => {
    setPendingFilters({
      coaching_name: null,
      batch_name: null,
      subject: null,
    });
    setAppliedFilters({});
  };

  const renderSection = (title, color, icon, data, loading) => (
    <div className='section'>
      <Title className='section-title' style={{ color }}>
        {title} {icon}
      </Title>
      {loading ? (
        <Spin className='section-spinner' />
      ) : data?.length > 0 ? (
        data.map((assignment) => (
          <AssignmentCard
            key={assignment.assignment_id}
            subjectName={assignment.assignment_name}
            postedOn={assignment.postedDate || "N/A"}
            dueDate={assignment.end_date}
            time={assignment.end_time}
          />
        ))
      ) : (
        <EmptyCard text={`No ${title.toLowerCase()} assignments`} />
      )}
    </div>
  );

  return (
    <div className='assignments-container'>
      <div className='filters'>
        <Select
          placeholder='Coaching'
          value={pendingFilters.coaching_name}
          onChange={(value) => handleFilterChange(value, "coaching_name")}
          options={coachingOptions}
          style={{ width: 120 }}
        />
        <Select
          placeholder='Course'
          value={pendingFilters.batch_name}
          onChange={(value) => handleFilterChange(value, "batch_name")}
          style={{ width: 120 }}
          options={[
            { value: "course1", label: "Course 1" },
            { value: "course2", label: "Course 2" },
          ]}
        />
        <Select
          placeholder='Subject'
          value={pendingFilters.subject}
          onChange={(value) => handleFilterChange(value, "subject")}
          style={{ width: 120 }}
          options={[
            { value: "english", label: "English" },
            { value: "maths", label: "Maths" },
            { value: "physics", label: "Physics" },
            { value: "chemistry", label: "Chemistry" },
          ]}
        />
        <Button type='primary' onClick={handleApplyFilters}>
          Apply
        </Button>
        <Button
          type='text'
          style={{ color: "red" }}
          icon={<StopOutlined />}
          onClick={handleClearFilters}
        />
      </div>

      <Title className='title'>Assignments</Title>

      {renderSection(
        "Pending",
        "#F8BD00",
        <ClockCircleOutlined />,
        pendingAssignments.data,
        pendingLoading
      )}

      {renderSection(
        "Submitted",
        "#59BD7D",
        <CheckCircleOutlined />,
        submittedAssignments.data,
        submittedLoading
      )}
    </div>
  );
};

export default PendingAll;
